module.exports = __webpack_public_path__ + "static/media/arrowDownGrey.f76f2856.svg";